import React from 'react'
import ReportWrapper from '../ReportWrapper'
import NonBankingApplicationRecordsOverview from './NonBankingApplicationRecordsOverview'
import NonBankingApplicationRecordsChart from './NonBankingApplicationRecordsChart'
import InstitutionalApplicationRecords from './InstitutionalApplicationRecords'
import SpecialPeriodApplicationRecords from './SpecialPeriodApplicationRecords'
import ReportSectionHeading from '../ReportSectionHeading'
import { Table, TableData, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import { useViewMode } from '../ViewModeProvider'

interface NonBankingApplicationRecordsProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function NonBankingApplicationRecords({ data, title, sectionIndex }: NonBankingApplicationRecordsProps) {
  const theme = useTheme()
  const { viewMode } = useViewMode()

  const periods = [
    {
      label: '近7天',
      applyCount: data?.nb_d7_apply_count ?? 0,
      orgCount: data?.nb_d7_apply_org_count ?? 0,
    },
    {
      label: '近15天',
      applyCount: data?.nb_d15_apply_count ?? 0,
      orgCount: data?.nb_d15_apply_org_count ?? 0,
    },
    {
      label: '近1月',
      applyCount: data?.nb_m1_apply_count ?? 0,
      orgCount: data?.nb_m1_apply_org_count ?? 0,
    },
    {
      label: '近3月',
      applyCount: data?.nb_m3_apply_count ?? 0,
      orgCount: data?.nb_m3_apply_org_count ?? 0,
    },
    {
      label: '近6月',
      applyCount: data?.nb_m6_apply_count ?? 0,
      orgCount: data?.nb_m6_apply_org_count ?? 0,
    },
    {
      label: '近1年',
      applyCount: data?.nb_m12_apply_count ?? 0,
      orgCount: data?.nb_m12_apply_org_count ?? 0,
    },
  ]

  const tableData: TableData = {
    head: ['统计周期', '申请次数', '申请机构数'],
    body: periods.map((period) => [period.label, period.applyCount, period.orgCount]),
  }

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <NonBankingApplicationRecordsOverview data={data} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          申请明细
        </Text>
        {viewMode === 'table' ? (
          <div className="mt-3">
            <Table
              data={tableData}
              highlightOnHover
              verticalSpacing="sm"
              styles={{
                table: { fontSize: '13px' },
                th: {
                  backgroundColor: theme.surfaceMutedColor,
                  color: theme.accentTextColor,
                },
              }}
            />
          </div>
        ) : (
          <div className="mt-3">
            <NonBankingApplicationRecordsChart data={data} />
          </div>
        )}
      </div>
      <InstitutionalApplicationRecords data={data} />
      <SpecialPeriodApplicationRecords data={data} />
    </ReportWrapper>
  )
}
